export function shuffleObject( object ) {
    let returnObject = {}
    let keys = Object.keys( object )

    keys.sort( ( a, b ) => {
        return Math.random() - 0.5
    } )

    keys.forEach( k => {
        returnObject[ k ] = object[ k ]
    } )

    return returnObject
}



// WEBPACK FOOTER //
// ./utilities/object.jsx